function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_without_properties(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
import cloneDeep from "lodash-es/cloneDeep";
import { FormPath } from "@formily/core";
import { PresetDataMap } from "./utils";
import { PathTool } from "./PathTool";
import { IPatternType, Pattern } from "./Pattern";
class DataMapper {
  collectDataMap(form, dataMap) {
    const formId = form.id;
    if (!this._formCollectionsMap[formId]) {
      this._formCollectionsMap[formId] = [];
    }
    this._formCollectionsMap[formId].push(dataMap);
  }
  clearFormDataMaps(form) {
    delete this._formCollectionsMap[form.id];
  }
  setInitialValues(form, data) {
    const newData = this.convertData(form.id, data);
    form.setInitialValues(newData);
  }
  setValues(form, data) {
    const newData = this.convertData(form.id, data);
    form.setValues(newData);
  }
  getInitialValues(form) {
    return this.revertData(form.id, form.initialValues);
  }
  getValues(form) {
    return this.revertData(form.id, form.values);
  }
  convertData(formId, data) {
    var _this__formCollectionsMap_formId;
    const collections = (_this__formCollectionsMap_formId = this._formCollectionsMap[formId]) !== null && _this__formCollectionsMap_formId !== void 0 ? _this__formCollectionsMap_formId : [];
    const newData = cloneDeep(data);
    for (const _ref of collections) {
      let collection = _ref;
      const { path, dataMap: { pathPattern, options } } = collection, dataMap = _object_without_properties(collection.dataMap, [
        "pathPattern",
        "options"
      ]);
      const exec = this._getDataMapExec(dataMap, "convert");
      if (PathTool.isArrayPath(path)) {
        const exactPaths = PathTool.collectExactPaths(path.noVoidPath(), newData);
        for (const exactPath of exactPaths) {
          const exactPathPattern = pathPattern && Pattern.transformPattern(pathPattern, (p) => PathTool.toExactPath(PathTool.toNoVoidStringPath(p), exactPath.indices));
          this._convertExact(exactPath.path, data, newData, exec, exactPathPattern, options);
        }
      } else {
        this._convertExact(path.noVoidPath(), data, newData, exec, pathPattern, options);
      }
    }
    return newData;
  }
  revertData(formId, data) {
    var _this__formCollectionsMap_formId;
    const collections = (_this__formCollectionsMap_formId = this._formCollectionsMap[formId]) !== null && _this__formCollectionsMap_formId !== void 0 ? _this__formCollectionsMap_formId : [];
    const newData = cloneDeep(data);
    for (let i = collections.length - 1; i >= 0; i--) {
      const _collections_i = collections[i], { path, dataMap: { pathPattern, destroy, options } } = _collections_i, dataMap = _object_without_properties(_collections_i.dataMap, [
        "pathPattern",
        "destroy",
        "options"
      ]);
      const exec = this._getDataMapExec(dataMap, "revert");
      if (PathTool.isArrayPath(path)) {
        const exactPaths = PathTool.collectExactPaths(path.noVoidPath(), newData);
        for (const exactPath of exactPaths) {
          const exactPathPattern = pathPattern && Pattern.transformPattern(pathPattern, (p) => PathTool.toExactPath(PathTool.toNoVoidStringPath(p), exactPath.indices));
          this._revertExact(exactPath.path, data, newData, exec, exactPathPattern, destroy, options);
        }
      } else {
        this._revertExact(path.noVoidPath(), data, newData, exec, pathPattern, destroy, options);
      }
    }
    return newData;
  }
  _getDataMapExec(dataMap, key) {
    let exec = dataMap[key];
    if (dataMap[key]) {
      exec = dataMap[key];
    } else if (dataMap.type) {
      var _PresetDataMap_dataMap_type;
      exec = (_PresetDataMap_dataMap_type = PresetDataMap[dataMap.type]) === null || _PresetDataMap_dataMap_type === void 0 ? void 0 : _PresetDataMap_dataMap_type[key];
    }
    if (exec) {
      const { isArray, arrayFilterEmpty, customArrayFilter } = dataMap;
      if (isArray) {
        return (value, data, effects, options) => {
          if (!value || !Array.isArray(value)) {
            return value;
          }
          let result = value.map((v) => exec(v, data, effects, options));
          if (arrayFilterEmpty) {
            result = result.filter((v) => v !== void 0 || v !== null);
          }
          if (customArrayFilter) {
            result = result.filter(customArrayFilter);
          }
          return result;
        };
      }
    }
    return exec;
  }
  _getValueByPattern(data, pattern) {
    const type = Pattern.getType(pattern);
    if (type === IPatternType.single) {
      const _pattern = pattern;
      const value = FormPath.getIn(data, PathTool.toNoVoidStringPath(_pattern));
      return value;
    }
    if (type === IPatternType.array) {
      const _pattern = pattern;
      return _pattern.map((p) => {
        const value = FormPath.getIn(data, PathTool.toNoVoidStringPath(p));
        return value;
      });
    }
    if (type === IPatternType.object) {
      const _pattern = pattern;
      const object = {};
      for (const entry of Object.entries(_pattern)) {
        const [key, p] = entry;
        object[key] = FormPath.getIn(data, PathTool.toNoVoidStringPath(p));
      }
      return object;
    }
  }
  _setValueByPattern(data, value, pattern) {
    const type = Pattern.getType(pattern);
    if (type === IPatternType.single) {
      const _pattern = pattern;
      FormPath.setIn(data, PathTool.toNoVoidStringPath(_pattern), value);
      return;
    }
    if (type === IPatternType.array) {
      const _pattern = pattern;
      if (Array.isArray(value)) {
        for (let i = 0; i < value.length; i++) {
          FormPath.setIn(data, PathTool.toNoVoidStringPath(_pattern[i]), value[i]);
        }
      }
      return;
    }
    if (type === IPatternType.object) {
      const _pattern = pattern;
      if (value && typeof value === "object") {
        for (const entry of Object.entries(_pattern)) {
          const [key, p] = entry;
          FormPath.setIn(data, PathTool.toNoVoidStringPath(p), value[key]);
        }
        return;
      }
    }
  }
  _deleteValueByPattern(data, pattern) {
    const type = Pattern.getType(pattern);
    if (type === IPatternType.single) {
      const _pattern = pattern;
      FormPath.deleteIn(data, PathTool.toNoVoidStringPath(_pattern));
      return;
    }
    if (type === IPatternType.array) {
      const _pattern = pattern;
      _pattern.forEach((p) => {
        FormPath.deleteIn(data, PathTool.toNoVoidStringPath(p));
      });
      return;
    }
    if (type === IPatternType.object) {
      const _pattern = pattern;
      for (const p of Object.values(_pattern)) {
        FormPath.deleteIn(data, PathTool.toNoVoidStringPath(p));
      }
      return;
    }
  }
  _executeEffects(data, effects) {
    const effectList = Array.isArray(effects) ? effects : [
      effects
    ];
    for (const effect of effectList) {
      const { path, value, destroy } = effect;
      const stringPath = PathTool.toNoVoidStringPath(path);
      if (destroy) {
        FormPath.deleteIn(data, stringPath);
      } else {
        FormPath.setIn(data, stringPath, value);
      }
    }
  }
  _convertExact(path, data, newData, exec, pathPattern, options) {
    if (exec || pathPattern) {
      const value = this._getValueByPattern(newData, pathPattern !== null && pathPattern !== void 0 ? pathPattern : path);
      const result = exec ? exec(value, data, (effects) => this._executeEffects(newData, effects), options) : value;
      if (pathPattern) {
        this._deleteValueByPattern(newData, pathPattern);
      }
      FormPath.setIn(newData, path, result);
    }
  }
  _revertExact(path, data, newData, exec, pathPattern, destroy, options) {
    if (destroy) {
      FormPath.deleteIn(newData, path);
      return;
    }
    if (exec || pathPattern) {
      const pattern = pathPattern !== null && pathPattern !== void 0 ? pathPattern : path;
      const value = FormPath.getIn(newData, path);
      let result = value;
      if (exec) {
        result = exec(value, data, (effects) => this._executeEffects(newData, effects), options);
      }
      if (pathPattern) {
        FormPath.deleteIn(newData, path);
      }
      this._setValueByPattern(newData, result, pattern);
    }
  }
  constructor() {
    _define_property(this, "_formCollectionsMap", {});
  }
}
export { DataMapper as default };
